import { EmptyState } from "@omnabase/ui";

/** An address under Settings that is unknown, or not the person's (a section outside their capabilities, a project they do not manage):
 *  the same plain not-found, never the administrator's page (2026-10-05, DECISIONS "Members in Settings"). */
export function NoSuchPage() {
  return <EmptyState icon="settings" title="No such settings page" text="Pick a section from the list." />;
}
